import { render } from "./IdentityComponent.vue?vue&type=template&id=00c50824"
import script from "./IdentityComponent.vue?vue&type=script&lang=js"
export * from "./IdentityComponent.vue?vue&type=script&lang=js"

import "./IdentityComponent.vue?vue&type=style&index=0&id=00c50824&lang=css"

import exportComponent from "/Users/noursafadi/Documents/Uni/Parsons-Spring-25/MajorStudio02/MSDV-thesis-2025/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__